import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

import { LoadingDialogData } from "@data/types/loading-dialog";
import { SpinnerComponent } from "@shared/components/spinner/spinner.component";
import { SpacerComponent } from "@shared/components/spacer/spacer.component";
import { TitleComponent } from "@shared/components/title/title.component";

@Component({
  selector: "app-loading-dialog",
  templateUrl: "./loading-dialog.component.html",
  styleUrls: ["./loading-dialog.component.scss"],
  imports: [SpinnerComponent, SpacerComponent, TitleComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class LoadingDialogComponent {
  data = inject<LoadingDialogData>(MAT_DIALOG_DATA);
}
